import React from 'react';
import { CircleBadge, CircleBadgeColor } from '../../../../CircleBadge';
import { ThreeDots } from 'react-bootstrap-icons';
import ReactTooltip from 'react-tooltip';

interface ScriptWrittenBadgeProps {
  id: string;
  scriptWrittenDates: string[];
}
const ScriptWrittenBadge = ({
  id,
  scriptWrittenDates,
}: ScriptWrittenBadgeProps) => {
  const child =
    scriptWrittenDates.length > 1 ? `${scriptWrittenDates.length}` : ThreeDots;
  return (
    <>
      <CircleBadge
        child={child}
        outerCircleColor={CircleBadgeColor.GREY}
        color={CircleBadgeColor.GREY}
        dataFor={`script-written-badge-${id}`}
        dataTip
      />
      <ReactTooltip id={`script-written-badge-${id}`} effect="solid">
        <div className="mb-1">
          <div className="mb-1">Script written</div>
          {scriptWrittenDates.map((dateStr) => (
            <>
              {dateStr}
              <br />
            </>
          ))}
        </div>
      </ReactTooltip>
    </>
  );
};

export default ScriptWrittenBadge;
